export default {
  navHome: "ホーム",
  navProspect: "見込み客",
  navCompanies: "企業",
  navEnrich: "データ拡充",
  navIntent: "ウェブサイトインテント",
  navSequence: "シーケンス",
  navInbox: "受信箱",
  navInboxDesc: "メールと LinkedIn のメッセージをひとつの場所で確認して返信",
  inboxSearchPlaceholder: "会話を検索",
  inboxEmptyState:
    "まだ会話がありません。シーケンスが開始されると、ここに返信が表示されます。",
  inboxEmptyConnectCta: "シーケンスを設定",
  channelEmail: "メール",
  channelLinkedIn: "LinkedIn",
  inboxMsgYou: "あなた",
  inboxSelectThreadTitle: "会話を選択",
  inboxThreadErrorTitle: "この会話を読み込めませんでした",
  inboxThreadErrorHint:
    "このスレッドに有効なチャネル接続がないか、データが利用できません。",
  inboxComposerHint: "⌘ + Enter で送信",
  inboxToggleProspect: "プロスペクト詳細を切り替え",
  inboxChannelFilter: "チャネルフィルター",
  inboxProspectContact: "連絡先",
  inboxProspectSequence: "シーケンス",
  inboxProspectActivity: "アクティビティ",
  inboxProspectLastInbound: "最後の返信",
  inboxProspectLastOutbound: "最後の送信",
  inboxProspectStatus: "ステータス",
  inboxProspectNoContact: "連絡先情報がありません。",
  inboxBulkSelected: "件選択中",
  inboxBulkMarkRead: "既読",
  inboxBulkToggle: "会話を選択",
  inboxTabProfile: "プロフィール",
  inboxTabActivity: "アクティビティ",
  inboxActivityEmpty: "この会話のアクティビティはまだありません。",
  inboxInsertVariable: "変数",
  inboxVarFullName: "氏名",
  inboxVarCompany: "会社",
  inboxVarTitle: "役職",
  inboxSequenceStep: "ステップ",
  inboxSequenceRunning: "実行中",
  inboxSequencePaused: "一時停止",
  inboxSequenceFinished: "完了",
  inboxSequenceArchived: "アーカイブ済み",
  inboxAsideConversations: "件の会話",
  inboxBulkToggleAll: "このページを全て選択",
  inboxSortBy: "並び替え",
  inboxSortRecent: "新しい順",
  inboxSortOldest: "古い順",
  inboxSortSender: "送信者 (A→Z)",
  inboxSortSubject: "件名 (A→Z)",
  inboxSortReplied: "返信あり優先",
  last_message_at: "最新メッセージ",
  first_message_at: "最初のメッセージ",
  reference_id: "送信者",
  subject: "件名",
  inboxAccountSingular: "アカウント",
  inboxAccountPlural: "アカウント",
  inboxRecentReplies: "最近の返信",
  inboxConnectedAs: "接続元",
  inboxActionInterested: "興味ありとして記録",
  inboxActionMarkAll: "すべて記録",
  inboxSelectThreadHint: "会話を選択してメッセージを表示します。",
  inboxReplyPlaceholder: "返信を入力…",
  inboxSuggestReply: "AI 返信候補",
  inboxSend: "送信",
  inboxFilterAll: "すべて",
  inboxFilterUnread: "未読",
  inboxFilterReplied: "返信済み",
  inboxFilterSnoozed: "スヌーズ",
  inboxFilterClosed: "クローズ済み",
  inboxActionSnooze: "スヌーズ",
  inboxActionMeetingBooked: "ミーティング予約済み",
  inboxActionNotInterested: "関心なしに設定",
  inboxActionArchive: "アーカイブ",
  inboxActionStopSequence: "シーケンスを停止",
  inboxArchetypeConcise: "簡潔",
  inboxArchetypeWithCta: "CTA付き",
  inboxArchetypeQuestionBack: "質問返し",
  actions: "操作",
  loading: "読み込み中…",
  navService: "サービス",
  navAccountCredit: "アカウントクレジット",
  navSetting: "設定",
  navSequenceDetail: "シーケンス詳細",
  companyDetail: "企業詳細",

  // nav desc
  filterYourSearchToFindPreciselyTargeted:
    "検索を絞り込んで、ターゲットを絞った企業のリストを見つける",
  filterYourSearchToFindHighlySpecific:
    "検索を絞り込んで、非常に具体的なターゲットリードのグループを見つける",
  instantlyEnhanceYourData:
    "さまざまなソースから貴重なインサイトや重要な詳細を追加して、データを即座に強化する",
  transformAnonymousWebsiteTrafficInto:
    "匿名のウェブサイトトラフィックをリアルタイムで特定し、B2Bリードに変える",
  personalizeYourOutreach:
    "アウトリーチを自動化およびパーソナライズして、時間を節約し、見込み客を引き付ける",
  comprehensiveBusinessSolutions:
    "お客様のニーズに合わせた包括的なビジネスソリューションとサポートサービス",

  discoverAndConnectWithPotentialBuyers: "潜在的な購入者を見つけて繋がる",
  activelySeekingYourSolutionToday:
    "今日あなたのソリューションを積極的に探している",
  Market_Intent: "市場インテント",
  Tools: "ツール",
  technologyLookup: "テクノロジー検索",
  domainLookup: "ドメイン検索",
  emailVerification: "Eメール検証",
  upgrade: "アップグレード",
  helpCenter: "ヘルプセンター",
  contactUs: "お問い合わせ",
  feedback: "フィードバック",
  hello: "こんにちは",
  clickToChange: "クリックして変更",
  yourProfile: "あなたのプロフィール",
  currentUsage: "現在の使用状況",
  upgradePlan: "プランのアップグレード",
  integrations: "統合",
  featureRequests: "機能リクエスト",
  change: "変更",
  en: "English",
  cn: "中文（簡）",
  tw: "中文（繁）",
  logout: "ログアウト",
  switchLanguage: "言語を正常に切り替えました",

  // button operation
  btnEdit: "編集",
  btnDelete: "削除",
  btnCancel: "キャンセル",
  btnFilters: "フィルター",
  btnView: "表示",
  btnAdd: "追加",
  btnRemove: "削除",

  // 操作提示
  removeSuccessfully: "正常に削除されました",
  saveSuccessfully: "正常に保存されました",
  createSuccessfully: "正常に作成されました",

  // 系统popup
  unableToProcessPayment:
    "支払いを処理できません：最新の請求書で支払いを完了できませんでした。",
  billingSettings: "請求設定",

  // wallet
  topupCredit: "クレジットチャージ",
  autoTopup: "自動チャージ",
  lastCalculated: "最終計算日",
  Enabled: "有効",
  Disabled: "無効",

  // user
  btnUpgrade: "アップグレード",

  // app update toast
  newVersionAvailable:
    "<strong>新しいバージョンが利用可能です</strong> — 再読み込みして最新の機能と修正を取得してください。このページで未保存の変更は失われる可能性があります。",
  Reload: "再読み込み",
  // TODO: translate (placeholders copied from en.js)
  inboxStatsToday: "Today",
  inboxStatsReplies: "Replies",
  inboxStatsPending: "Pending",
  inboxStatsActiveSequences: "Active sequences",
  inboxOpenEmpty: "Open the inbox to see your latest replies.",
  inboxRefresh: "Refresh inbox",
  inboxSuggestFollowUp: "Suggest follow-up",
  inboxInsightAge: "Age",
  inboxSuggestModePick: "Choose draft type",
  inboxSuggestModeReply: "Reply (prospect wrote last)",
  inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
  inboxSuggestModeAuto: "Auto (detect from thread)",
  inboxFilterArchived: "Archived",
  inboxFilterDone: "Done",
  inboxStatusMeetingBooked: "Meeting booked",
  inboxStatusNotInterested: "Not interested",
  inboxStatusInterested: "Interested",
  inboxFilterOpen: "Active",
  inboxMsgSent: "Sent",
  inboxClickToOpen: "Click to open",
  inboxKpiSentToday: "Sent today",
  inboxKpiUnread: "Unread",
  inboxKpiRepliedToday: "Replies",
  inboxKpiSentWeek: "Sent this week",
  inboxKpiInbox: "in inbox",
  inboxKpiTotal: "total",
  inboxGlanceTopSequences: "Top sequences (30 days)",
  inboxLinkBtn: "Link",
  inboxLinkPromptUrl: "Link URL",
  inboxLinkPromptErr: "Enter a URL starting with http(s)://",
  inboxComposerDropHint: "Drop to attach",
  inboxFilterChannel: "Channel",
  inboxFilterCredential: "Credential",
  inboxFilterSequence: "Sequence",
  inboxFilterStatus: "Status",
  inboxFilterClassification: "Reply type",
  inboxFilterDateRange: "Date range",
  inboxFilterDateRangePh: "Pick a date range",
  inboxFilterClass_real: "Real replies only",
  inboxFilterClass_bounce: "Bounces",
  inboxFilterClass_auto_reply: "Auto-replies",
  inboxClassBounce: "Bounce",
  inboxClassBounceHint: "Delivery failed — this isn't a real reply",
  inboxClassAutoReply: "Auto-reply",
  inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
  inboxStepEvents: "events",
  inboxBulkMarkUnread: "Unread",
  inboxBulkInterested: "Interested",
  inboxBulkNotInterested: "Not interested",
  inboxSnoozeDialogTitle: "Snooze until",
  inboxSnoozeCustom: "Pick a custom date and time",
  inboxSnoozeCustomPh: "Select date & time",
  inboxSnoozeConfirm: "Snooze",
  inboxSnoozePreset1h: "Later today (1h)",
  inboxSnoozePreset4h: "Later today (4h)",
  inboxSnoozePresetTom: "Tomorrow morning",
  inboxSnoozePresetMon: "Next Monday",
  inboxSnippetBtn: "Snippets",
  inboxSnippetSearch: "Search snippets",
  inboxSnippetNew: "New snippet",
  inboxSnippetManage: "Manage",
  inboxSnippetCreate: "Create your first snippet",
  inboxSnippetCreateTitle: "New snippet",
  inboxSnippetEditTitle: "Edit snippet",
  inboxSnippetManager: "Manage snippets",
  inboxSnippetEmpty: "No saved snippets yet.",
  inboxSnippetFieldName: "Name",
  inboxSnippetFieldChannel: "Channel (optional)",
  inboxSnippetFieldBody: "Body",
  inboxSnippetChannelAny: "Any channel",
  inboxSnippetNamePh: "e.g. Friendly follow-up",
  inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
  btnSave: "Save",
  inboxProspectTracking: "Tracking",
  inboxOpened: "Opened",
  inboxClicked: "Clicked",
  inboxLast: "last",
  of: "of",
  inboxAttachBtn: "Attach",
  inboxAttachTooBig: "Total attachment size exceeds 24MB.",
  noData: "No results",
  inboxCopy: "Copy",
  inboxCopied: "Copied",
  inboxCopyEmail: "Copy email",
  inboxCopiedEmail: "Email copied",
  inboxCopyPhone: "Copy phone",
  inboxCopiedPhone: "Phone copied",
  inboxOpenLinkedIn: "Open LinkedIn",
  inboxOpenTwitter: "Open X / Twitter",
  inboxProspectCompany: "Company",
  inboxProspectInsights: "Insights",
  inboxInsightMessages: "Messages",
  inboxInsightSince: "Open",
  inboxAgeToday: "Today",
  inboxEmptyTitle: "No conversations yet",
  inboxSelectionPicker: "Selection options",
  inboxSelectionTitle: "Select conversations",
  inboxSelectThisPage: "This page",
  inboxSelectAll: "All conversations",
  inboxSelectCustom: "Custom",
  inboxSelectAllHint:
    "Selecting beyond this page fetches additional pages from the server.",
  applySelection: "Apply",
  theQuantityCannotBeZero: "Pick a non-zero count",
  inboxCompanyName: "Name",
  inboxCompanyIndustry: "Industry",
  inboxCompanySize: "Size",
  inboxCompanyLocation: "Location",
  inboxCompanyWebsite: "Website",
  inboxCompanyLinkedIn: "LinkedIn",
  inboxShowTrimmed: "Show trimmed content",
  inboxShowTrimmedHint: "Show the rest of this message",
  inboxFieldTo: "To",
  inboxFieldToPh: "recipient@example.com",
  inboxFieldToLinkedInPh: "Recipient",
  inboxFieldCc: "Cc",
  inboxFieldCcPh: "cc@example.com, …",
  inboxFieldBcc: "Bcc",
  inboxFieldBccPh: "bcc@example.com, …",
  inboxFieldSubject: "Subject",
  inboxFieldSubjectPh: "Subject",
  inboxFieldLocked: "Auto-filled — cannot edit",
  inboxTrackSent: "Sent",
  inboxTrackSentHint: "Messages we sent in this thread",
  inboxTrackReplies: "Replies",
  inboxTrackRepliesHint: "Inbound messages from the prospect",
  inboxTrackOpens: "Opens",
  inboxTrackOpensHint: "Times the recipient opened a tracked message",
  inboxTrackClicks: "Clicks",
  inboxTrackClicksHint: "Tracked links the recipient clicked",
  inboxTrackReads: "Reads",
  inboxTrackReadsHint:
    "Times the recipient read this thread (LinkedIn read receipts)",
  inboxTrackReactions: "Reactions",
  inboxTrackReactionsHint: "Reactions on our outbound messages",
  inboxMsgNoOpenYet: "No opens recorded yet",
  inboxMsgNoClickYet: "No clicks recorded yet",
  inboxActivityReplyReceived: "Reply received",
  inboxActivityOpenRecorded: "Email opened",
  inboxActivityClickRecorded: "Link clicked",
  inboxActivitySendEmail: "Email sent",
  inboxActivitySendLinkedIn: "LinkedIn message sent",
  inboxActivitySendInvite: "LinkedIn invite sent",
  inboxActivityFailed: "failed",
  inboxComposerExpand: "Expand composer",
  inboxComposerCollapse: "Collapse composer",
  inboxComposerMinimise: "Minimise composer",
  inboxComposerRestore: "Restore composer",
  inboxComposerReply: "Reply…",
  inboxReplyModeReply: "Reply",
  inboxReplyModeReplyAll: "Reply all",
  inboxRecipientNoMatch: "Type an email and press Enter",
  inboxSignatureToggle: "Toggle signature",
  inboxSignatureTitle: "Email signature",
  inboxSignaturePh: "Best regards,\nYour name",
  inboxSignatureOn: "Signature ON — click to remove",
  inboxSignatureOff: "Signature OFF — click to insert",
  inboxSignatureRightClickEdit: "right-click to edit",
  inboxSignatureRightClickHint:
    "Tip: right-click the signature button to edit.",
  Refresh: "Refresh",
  Show: "Show",
  Hide: "Hide",
  Next: "Next",
  // pagination
  pagination_per_page: "{size} / ページ",
  pagination_go_to: "移動",
};
